import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import { API_BASE_URL } from '../../const.js';


export default class SummaryRerport extends React.Component {
    constructor(props) {
        super(props)
        const args = props.args === undefined ? {} : props.args
        const now = new Date();
        const startOfYear = new Date(now.getFullYear(), 0, 1);
        const endOfYear = new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999);

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

        this.state = {
              args: args, 
              startReportDate: formatDate(startOfYear),
              endReportDate:  formatDate(endOfYear),
              programs: [],
              reportId: "",
              reportSuccess: false  
        }
        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.getReport = this.getReport.bind(this);   
    }  
    
    

    handleChangeStart(event) {
        this.setState({startReportDate:  event.target.value})
    }

    handleChangeEnd(event) {
       this.setState({endReportDate:  event.target.value})
    }


    getReport(event) {
        const params = {'date_from': this.state.startReportDate, 'date_to': this.state.endReportDate}
        this.setState({reportId: "", reportSuccess: false})
        BaseApi.post('/project/report/summary', params, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
            .then(res => { 
                const uuid = res.data['uuid']
                this.setState({reportId: uuid, reportSuccess: true})
                window.open(`${API_BASE_URL}project/report/summary/${uuid}`, "blank")
            })
            .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Сводный отчет"}/>
                <div className="card shasow-sm">
                    <div className="card-body">
                        <form>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="start" className="form-label">Начало</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="start"
                                        value={this.state.startReportDate || ""}
                                        onChange={this.handleChangeStart}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="end" className="form-label">Завершение</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="end"
                                        value={this.state.endReportDate || ""}
                                        onChange={this.handleChangeEnd}
                                    />
                                </div>
                            </div>
                            <div className="mt-4 d-flex justify-content-end">
                               
                                <div class="row mt-3">
                                    <button class="btn btn-primary w-100" onClick={this.getReport}>Сформировать</button>   
                                </div>
                            </div> 

                            
                        </form>
                    </div>
                </div>

            </div> 
        )       
    }
}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/summary-report.js